import React from "react";
import { Container, Nav, NavItem } from "reactstrap";

import { NavLink } from "./NavbarDashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
export function PageHeader({ children }) {
  return (
    <div className="bg-white pb-0 pt-4">
      <Container>{children}</Container>
    </div>
  );
}

export function PageHeaderTitle({ children }) {
  return <h1 className="font-weight-bold">{children}</h1>;
}

export function PageHeaderTabs({ tabs }) {
  return (
    <Nav className="d-flex ml-n4">
      {tabs.map((tab) => (
        <NavItem key={tab.id} className="d-flex ml-4">
          <NavLink
            to={tab.path}
            className="align-self-center"
            inactiveClassName="text-dark"
          >
            {tab.label}{" "}
            {tab.label === "Plantillas despachos" && (
              <FontAwesomeIcon
                icon={faBell}
                style={{ marginLeft: "9px" }}
                color={"#f37b33"}
              />
            )}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
}

PageHeader.Title = PageHeaderTitle;
PageHeader.Tabs = PageHeaderTabs;
